import type { NotificationFilter, UserType } from '@tyro/api';

export const shellKeys = {
  all: ['shell'] as const,
  notifications: {
    all: () => [...shellKeys.all, 'notifications'] as const,
    list: (filter: NotificationFilter) =>
      [...shellKeys.notifications.all(), 'list', filter] as const,
    unreadCount: () =>
      [...shellKeys.notifications.all(), 'unreadCount'] as const,
  },
  whatsNew: {
    all: () => [...shellKeys.all, 'whatsNew'] as const,
    list: (userType: UserType) =>
      [...shellKeys.whatsNew.all(), 'list', userType] as const,
  },
  tyrone: {
    all: () => [...shellKeys.all, 'tyrone'] as const,
    conversations: () => [...shellKeys.tyrone.all(), 'conversations'] as const,
    conversation: (conversationId: string) =>
      [...shellKeys.tyrone.all(), 'conversation', conversationId] as const,
  },
};
